import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";

export const useDeleteExam = () => {

    const axios = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { message } = App.useApp();

    const deleteExam = async (id: string) => {
        try {
            await axios.delete(`/api/exam/${id}`);
        } catch (error) {
            throw new Error(t("messages.error.examDelete"));
        }
    };

    return useMutation({
        mutationFn: deleteExam,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["exams"] });
            message.success(t("messages.success.deleteExam"));
        },
    });
}